// Module
var code = " <div class=\"mas-p-5\"> <input type=\"text\" name=\"1\" class=\"form-control\" ng-model=\"$ctrl.critere.modelSelectionCritereValeur[0].valeur1\" style=\"margin:0\"/> </div> ";
// Exports
module.exports = code;